import {
  getUserDocumentsRepository,
  getDocumentByIdRepository,
  getDocumentsByUserRepository
} from "../Infrastructure/Documents.repository";

export const getUserDocumentsLogic = (params) =>
  getUserDocumentsRepository(params);

export const getDocumentByIdLogic = (id) =>
  getDocumentByIdRepository(id);

export const getDocumentsByUserLogic = (params) => {
  console.log("getDocumentsByUserLogic called with params:", params);
  return getDocumentsByUserRepository(params);
};